import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/atoms/Typography';
import { Form } from '@/components/forms/core/Form';
import { Button } from '@/components/molecules/Button';

import { ChangePasswordSchema, ChangePasswordSchemaType } from './schema';
import { PasswordInput } from '@/components/forms/base/PasswordInput';
import { useUpdateUserPassword } from '@/api/hooks/useUser';

export interface ChangePasswordFormProps {
  onSuccess?: (data: any) => void;
}

export const ChangePasswordForm = ({ onSuccess }: ChangePasswordFormProps) => {
  const { t } = useTranslation();

  const updateUserPasswordMutation = useUpdateUserPassword({
    onSuccess
  });

  const handleSubmit = async (data: ChangePasswordSchemaType) => {
    updateUserPasswordMutation.mutate(data);
  };

  return (
    <div className="gap-4 flex flex-col w-full">
      <Typography variant="h3" weight="bold">
        {t('form.changePasswordFormTitle')}
      </Typography>
      <Form
        data-testid="change-password-form"
        schema={ChangePasswordSchema}
        onSubmit={handleSubmit}
        className="flex flex-col gap-5"
        render={({ formState }) => (
          <>
            <PasswordInput id="oldPassword" label={t('form.oldPassword')} placeholder={t('form.oldPasswordPlaceholder')} required />
            <PasswordInput id="newPassword" label={t('form.newPassword')} placeholder={t('form.newPasswordPlaceholder')} required />
            <PasswordInput id="confirmPassword" label={t('form.confirmNewPassword')} placeholder={t('form.confirmNewPasswordPlaceholder')} required />
            <div>
              <Button
                type="submit"
                color="primary"
                label={t('form.save')}
                loading={updateUserPasswordMutation.isLoading}
                disabled={!formState.isDirty || updateUserPasswordMutation.isLoading}
              />
            </div>
          </>
        )}
      />
    </div>
  );
};
